// extracted by mini-css-extract-plugin
export default {"form":"eM0h1","button":"Js2cH","info":"e2DRH","infoText":"_w9XS","passwordIcon":"FJX4O","taxNumber":"tqxZh","taxNumberLoading":"LAnw_"};